import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  SecurityContext,
} from "@angular/core";
import { trigger, style, transition, animate } from "@angular/animations";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "ds-banner",
  templateUrl: "./ds-banner.component.html",
  styleUrls: ["./ds-banner.component.scss"],
  animations: [
    trigger("fadeIn", [
      transition("visible => hidden", [
        animate(
          "100ms ease-in",
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
})
export class DsBannerComponent implements OnInit, OnChanges {
  @Input() type: string = "neutral";
  @Input() message!: string;
  @Input() actionLabel?: string = "";
  @Input() closeable: boolean = true;
  @Input() closeOnAction: boolean = true;

  @Output() callAction = new EventEmitter<void>();

  icon: string;
  visible: boolean = true;
  animationState: string = "visible";
  sanitizedMessage: string = "";

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.checkIcon();
    this.sanitizeMessage();
  }

  close() {
    this.animationState = "hidden";
  }

  onAnimationDone(event: any) {
    if (event.toState === "hidden") {
      this.visible = false;
    }
  }

  onAction() {
    this.callAction.emit();
    if (this.closeOnAction) {
      this.close();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["type"]) {
      this.checkIcon();
    }
    if (changes["message"]) {
      this.sanitizeMessage();
    }
  }

  checkIcon() {
    switch (this.type) {
      case "neutral":
        this.icon = "info-line";
        break;
      case "warning":
        this.icon = "warning-line";
        break;
      case "success":
        this.icon = "check-line";
        break;
      case "danger":
        this.icon = "exclamation-line";
        break;
      default:
        this.icon = "info-line";
        break;
    }
  }

  sanitizeMessage() {
    if (this.message) {
      const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, this.message);
      this.sanitizedMessage = sanitized || "";
    } else {
      this.sanitizedMessage = "";
    }
  }
}
